// todo: figure out an override issue from previous outdated events
// function gospelMeetingCountdown() {
//     return leadInLogoGospelMeeting(
//         "Starting soon...",
//         '<span class="countdown__value">2:00</span>',
//         '<img alt="Edwin Crozier" src="https://www.cedarparkchurchofchrist.org/media/uploads/public/gospel-meeting/2024-learning-prayer/edwin_crozier.jpg" />',
//     );
// }
export const worshipTimes = [
    /* GOSPEL MEETING */
    // {
    //     title: "Singing",
    //     date: new Date("01/10/25 12:30 PM"),
    //     day: "Saturday",
    //     time: "12:30", // aim to refresh at 6:00 pm
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false, // every seven days
    //     secondary: true,
    //     msg: "...",
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // {
    //     title: "singing",
    //     date: new Date("01/10/25 1:00 PM"),
    //     day: "Saturday",
    //     time: "1:00",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     msg: "...",
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Map],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // {
    //     title: "Wednesday end (Logo Only)",
    //     day: "Saturday",
    //     date: new Date("01/11/25 5:30 PM"),
    //     time: "5:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     msg: "...",
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // /////////
    // {
    //     title: "Singing",
    //     date: new Date("01/10/25 6:30 PM"),
    //     day: "Friday",
    //     time: "6:30", // aim to refresh at 6:00 pm
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false, // every seven days
    //     secondary: true,
    //     msg: "...",
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // {
    //     title: "singing",
    //     date: new Date("01/10/25 7:00 PM"),
    //     day: "Friday",
    //     time: "7:00",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     msg: "We'll begin soon",
    //     ignoreCountdown: false,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.Website,
    //             SlideIndex.WorshipTimes,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.Website,
    //             SlideIndex.WorshipTimes,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //     },
    // },
    // {
    //     title: "singing",
    //     date: new Date("01/10/25 8:30 PM"),
    //     day: "Friday",
    //     time: "8:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     msg: "...",
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.ThankYou,
    //             SlideIndex.Website,
    //             SlideIndex.WorshipTimes,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.ThankYou,
    //             SlideIndex.Website,
    //             SlideIndex.WorshipTimes,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //     },
    // },
    // {
    //     title: "Wednesday end (Logo Only)",
    //     day: "Wednesday",
    //     date: new Date("01/10/25 9:30 PM"),
    //     time: "9:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     msg: "...",
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // Monday
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Seeing the Lost",
    //     date: new Date("10/14/24 6:30 PM"),
    //     day: "Monday",
    //     time: "6:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // {
    //     // main
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Seeing the Lost",
    //     date: new Date("10/14/24 7:00 PM"),
    //     day: "Monday",
    //     time: "7:00",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: false,
    //     // msg: gospelMeetingCountdown(),
    //     msg: "Starting soon...",
    //     slideIndex: SlideIndex.GospelMeetingTemp,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.WorshipPointer,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Seeing the Lost",
    //     date: new Date("10/14/24 7:35 PM"), // refresh 7:05
    //     day: "Monday",
    //     time: "7:35",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.LogoOnlyStart,
    //             SlideIndex.GospelMeeting,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.LogoOnlyStart,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Seeing the Lost",
    //     date: new Date("10/14/24 8:25 PM"), // refresh 7:55
    //     day: "Monday",
    //     time: "8:25",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.ThankYou, SlideIndex.GospelMeeting],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.ThankYou,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //             SlideIndex.WorshipTimes,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Seeing the Lost",
    //     date: new Date("10/14/24 9:30 PM"), // refresh 9:00 PM
    //     day: "Monday",
    //     time: "9:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // // Tuesday
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Go Into Your World",
    //     date: new Date("10/15/24 6:30 PM"),
    //     day: "Tuesday",
    //     time: "6:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // {
    //     // main
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Go Into Your World",
    //     date: new Date("10/15/24 7:00 PM"),
    //     day: "Tuesday",
    //     time: "7:00",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: false,
    //     msg: "Starting soon...",
    //     slideIndex: SlideIndex.GospelMeetingTemp,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.WorshipPointer,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Go Into Your World",
    //     date: new Date("10/15/24 7:35 PM"), // refresh 7:05
    //     day: "Tuesday",
    //     time: "7:35",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.LogoOnlyStart,
    //             SlideIndex.GospelMeeting,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.LogoOnlyStart,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Go Into Your World",
    //     date: new Date("10/15/24 8:25 PM"), // refresh 7:55
    //     day: "Tuesday",
    //     time: "8:25",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.ThankYou, SlideIndex.GospelMeeting],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.ThankYou,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //             SlideIndex.WorshipTimes,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Go Into Your World",
    //     date: new Date("10/15/24 9:30 PM"), // refresh 9:00 PM
    //     day: "Tuesday",
    //     time: "9:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // // Wednesday
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Attention to Visitors",
    //     date: new Date("10/16/24 6:30 PM"),
    //     day: "Wednesday",
    //     time: "6:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    // {
    //     // main
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Attention to Visitors",
    //     date: new Date("10/16/24 7:00 PM"),
    //     day: "Wednesday",
    //     time: "7:00",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: false,
    //     msg: "Starting soon...",
    //     slideIndex: SlideIndex.GospelMeetingTemp,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.WorshipPointer,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.Welcome,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //             SlideIndex.Informer,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Attention to Visitors",
    //     date: new Date("10/16/24 7:35 PM"), // refresh 7:05
    //     day: "Wednesday",
    //     time: "7:35",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.LogoOnlyStart,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Informer,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.LogoOnlyStart,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //             SlideIndex.Informer,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Attention to Visitors",
    //     date: new Date("10/16/24 8:25 PM"), // refresh 7:55
    //     day: "Wednesday",
    //     time: "8:25",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [
    //             SlideIndex.ThankYou,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Informer,
    //         ],
    //         [GroupIndex.Auditorium]: [
    //             SlideIndex.ThankYou,
    //             SlideIndex.GospelMeeting,
    //             SlideIndex.Website,
    //             SlideIndex.StandStrongPodcast,
    //             SlideIndex.WorshipTimes,
    //             SlideIndex.Members,
    //         ],
    //     },
    // },
    // {
    //     customClass: "gospel-meeting",
    //     id: "gospel-meeting",
    //     title: "Attention to Visitors",
    //     date: new Date("10/16/24 9:30 PM"), // refresh 9:00 PM
    //     day: "Wednesday",
    //     time: "9:30",
    //     period: "PM",
    //     timezone: "CST",
    //     repeat: false,
    //     secondary: true,
    //     ignoreCountdown: true,
    //     slideGroups: {
    //         [GroupIndex.Foyer]: [SlideIndex.Resting],
    //         [GroupIndex.Auditorium]: [SlideIndex.Resting],
    //     },
    // },
    /* REGULAR TIMES OF WORSHIP */
    {
        title: "Sunday start (Logo Only)",
        day: "Sunday",
        time: "8:30", // aim to refresh at 8:00 am
        period: "AM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [0 /* SlideIndex.Resting */],
            [1 /* GroupIndex.Auditorium */]: [0 /* SlideIndex.Resting */],
        },
    },
    {
        title: "Sunday worship",
        day: "Sunday",
        time: "9:00", // 8:30 refresh
        period: "AM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: false,
        msg: "Worship will begin soon",
        ignoreCountdown: false,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                3 /* SlideIndex.Welcome */,
                7 /* SlideIndex.GospelMeeting */,
                13 /* SlideIndex.WorshipPointer */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                3 /* SlideIndex.Welcome */,
                7 /* SlideIndex.GospelMeeting */,
                6 /* SlideIndex.GuestSpeakers */,
                15 /* SlideIndex.CurrentBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                9 /* SlideIndex.Informer */,
            ],
        },
    },
    {
        title: "Sunday bible class",
        day: "Sunday",
        time: "9:45", // 9:15 refresh
        period: "AM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: false,
        msg: "Bible class will begin soon",
        ignoreCountdown: false,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                3 /* SlideIndex.Welcome */,
                7 /* SlideIndex.GospelMeeting */,
                15 /* SlideIndex.CurrentBibleClassAnnouncements */,
                1 /* SlideIndex.Map */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                2 /* SlideIndex.LogoOnlyStart */,
                7 /* SlideIndex.GospelMeeting */,
                6 /* SlideIndex.GuestSpeakers */,
                15 /* SlideIndex.CurrentBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                9 /* SlideIndex.Informer */,
            ],
        },
    },
    {
        title: "Sunday worship",
        day: "Sunday",
        time: "10:45", // 10:15 refresh
        period: "AM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: false,
        msg: "Worship will begin soon",
        ignoreCountdown: false,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                3 /* SlideIndex.Welcome */,
                13 /* SlideIndex.WorshipPointer */,
                7 /* SlideIndex.GospelMeeting */,
                6 /* SlideIndex.GuestSpeakers */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                2 /* SlideIndex.LogoOnlyStart */,
                7 /* SlideIndex.GospelMeeting */,
                6 /* SlideIndex.GuestSpeakers */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                9 /* SlideIndex.Informer */,
            ],
        },
    },
    {
        title: "Sunday worship (after services)",
        day: "Sunday",
        time: "12:15", // 11:45 pm refresh
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                4 /* SlideIndex.ThankYou */,
                7 /* SlideIndex.GospelMeeting */,
                14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                10 /* SlideIndex.Members */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                4 /* SlideIndex.ThankYou */,
                7 /* SlideIndex.GospelMeeting */,
                14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
            ],
        },
    },
    {
        title: "Sunday (Logo Only)",
        day: "Sunday",
        time: "1:15", // aim to refresh at 12:45 pm
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [0 /* SlideIndex.Resting */],
            [1 /* GroupIndex.Auditorium */]: [0 /* SlideIndex.Resting */],
        },
    },
    {
        title: "Wednesday end (Logo Only)",
        day: "Wednesday",
        time: "6:30", // aim to refresh at 6:00 pm
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [0 /* SlideIndex.Resting */],
            [1 /* GroupIndex.Auditorium */]: [0 /* SlideIndex.Resting */],
        },
    },
    {
        title: "Wednesday",
        day: "Wednesday",
        time: "7:00",
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: false,
        msg: "Bible class will begin soon",
        ignoreCountdown: false,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                3 /* SlideIndex.Welcome */,
                15 /* SlideIndex.CurrentBibleClassAnnouncements */,
                1 /* SlideIndex.Map */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                3 /* SlideIndex.Welcome */,
                7 /* SlideIndex.GospelMeeting */,
                6 /* SlideIndex.GuestSpeakers */,
                15 /* SlideIndex.CurrentBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                9 /* SlideIndex.Informer */,
            ],
        },
    },
    {
        title: "Wednesday (during/after bible class)",
        day: "Wednesday",
        time: "7:35", // aim to refresh at 7:05 pm
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                2 /* SlideIndex.LogoOnlyStart */,
                7 /* SlideIndex.GospelMeeting */,
                14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
                9 /* SlideIndex.Informer */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                2 /* SlideIndex.LogoOnlyStart */,
                7 /* SlideIndex.GospelMeeting */,
                6 /* SlideIndex.GuestSpeakers */,
                14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                9 /* SlideIndex.Informer */,
            ],
        },
    },
    {
        title: "Wednesday (services is done)",
        day: "Wednesday",
        time: "8:25", // aim to refresh at 7:55 pm
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [
                4 /* SlideIndex.ThankYou */,
                7 /* SlideIndex.GospelMeeting */,
                14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                10 /* SlideIndex.Members */,
            ],
            [1 /* GroupIndex.Auditorium */]: [
                4 /* SlideIndex.ThankYou */,
                7 /* SlideIndex.GospelMeeting */,
                14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
                12 /* SlideIndex.WorshipTimes */,
                5 /* SlideIndex.StandStrongPodcast */,
                11 /* SlideIndex.Website */,
                9 /* SlideIndex.Informer */,
            ],
        },
    },
    {
        title: "Wednesday end (Logo Only)",
        day: "Wednesday",
        time: "9:15", // aim to refresh at 8:45 pm
        period: "PM",
        timezone: "CST",
        repeat: 7, // every seven days
        secondary: true,
        msg: "...",
        ignoreCountdown: true,
        slideGroups: {
            [0 /* GroupIndex.Foyer */]: [0 /* SlideIndex.Resting */],
            [1 /* GroupIndex.Auditorium */]: [0 /* SlideIndex.Resting */],
        },
    },
];
